module.exports = __webpack_public_path__ + "src/img/zalando/img-ipad.41ee4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-ipad.jpg
// module id = 122
// module chunks = 0